<template>
  <div id="app" class="bg-dark-gray h-screen w-screen overflow-x-hidden">
    <router-view />
  </div>
</template>
